<template>
  <div class="solutions container">
    <hp-catalog-table
        :table-cfg="catalogTableCfg" isAllSolutions=table-cfg.isAllSolutions />
  </div>
</template>

<script>
  import HpCatalogTable from "./HpCatalogTable.vue";
  import CatalogTableCfg from '../js/TableCfg.js';
  import {API, Constants, TABLE} from '../js/Constants.js';

  export default {
    name: 'solutions',
    components: {
      HpCatalogTable
    },
    data() {
      return {
        catalogTableCfg: new CatalogTableCfg(),
      };
    },
    created() {
      this.initCatalogTableSettings();
    },
    methods: {
      initCatalogTableSettings() {
         sessionStorage.removeItem("solutionofmonth");
        const tableCfg = new CatalogTableCfg();
        tableCfg.buttonsData = {};
        tableCfg.columnList = this.columnList;
        tableCfg.columnDefinitions = this.columnDefinitions;
        tableCfg.defaultSortField = TABLE.FIELD_NAME.APP.LAST_UPDATE_TIME;
        tableCfg.filterUrl = [API.FILTERS_APP];
        tableCfg.loadCount = Constants.CARD_TABLE_DEFAULT_ITEM_NUMBER_PER_ROW * 3;
        tableCfg.showFilter = true;
        tableCfg.showOrder = true;
        tableCfg.tableId = TABLE.ID.SOLUTIONS.SOLUTIONS_CATALOG;
        tableCfg.url = null;
        this.catalogTableCfg = tableCfg;
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import "../styles/hpConstant.scss";
</style>
